module.exports = "<div ng-style=\"{'background-image': 'url(' + vm.logoPath + ')'}\"></div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/logo/logo.html
 ** module id = 165
 ** module chunks = 0
 **/